"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/components/auth-provider";

export default function HomePage() {
  const router = useRouter();
  const { user } = useAuth();
  useEffect(() => {
    if (user) router.replace("/home");
  }, [user, router]);
  return null;
}
